import React, { useEffect, useRef, useState } from 'react'
import contact from '../assets/Carousel/St Albans Banner 03.png'
import { aiObituaryGeneratorAPI } from '../serverApi/server';
import Skeleton from './skeleton/Skeleton';

const SoulScript = () => {
  const [inputValue, setInputValue] = useState({
    fullName: '',
    akaAlsoKnownAs: '',
    ageAtTheTimeOfDemise: '',
    dateAndPlaceOfBirth: '',
    dateAndPlaceOfDemise: '',
    familyMembersWhoHavePrecededThemIntoEternity: '',
    survivingFamilyMembers: '',
    educationCareerHobbiesAndInterests: '',
    accomplishmentsOrContributionsTheyMadeToTheirCommunityOrSociety: '',
    personalTraitsThatMadeThemSpecial: '',
    serviceOrMemorialArrangements: '',
    anyPersonalMessageOrSpecialRequestsYouWouldLikeToInclude: '',
    additionalInformationLikeChildhoodOrSpecialBond: ''
  });
  const [error, setError] = useState(false);
  const [AIGenerated, setAIGenerated] = useState('');
  const [skeletonArea, setSkeletonArea] = useState(false);

  const handleChange = (e) => {
    setError(false);
    const { name, value } = e.target;
    setInputValue((prevState) => ({
      ...prevState,
      [name]: value.replace(/\s{2,}/g, ' ')
    }));
  }

  const handleSubmit = async () => {
    if (!inputValue) {
      setError(true);
      return;
    }
    if (inputValue) {
      setAIGenerated('');
      setSkeletonArea(true);
      setError(false);
      try {
        const aiObituaryGeneratorAPIResponse = await aiObituaryGeneratorAPI(inputValue);
        setAIGenerated(aiObituaryGeneratorAPIResponse.data.gen_ai_response);
      } catch (error) {
        console.error(error);
        setAIGenerated('Error generating obituary. Please try again.');
      }
      setSkeletonArea(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      
      const inputs = document.querySelectorAll('.assistanceClass');
      let currentIndex = -1;
  
      inputs.forEach((input, index) => {
        if (input === e.target) {
          currentIndex = index;
        }
      });
  
      const nextEmpty = Array.from(inputs).slice(currentIndex + 1).find(input => !input.value);
      
      if (nextEmpty) {
        nextEmpty.focus();
      } else {
        const allFilled = Array.from(inputs).every(input => input.value.trim() !== '');
        if (allFilled) {
          handleSubmit();
        }
      }
    }
  };
  

  const aiContentRef = useRef(null);

  useEffect(() => {
    if (AIGenerated && aiContentRef.current) {
      aiContentRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [AIGenerated]); 
  
  /* const handleResize = () => {
    const textarea = aiContentRef.current;
    if (textarea.scrollHeight > window.innerHeight) {
      // If content is larger than the screen, set height to 85% of the screen
      textarea.style.height = '85vh';
    } else {
      // Otherwise, allow the textarea to take full height of the screen
      textarea.style.height = 'fit';
    }
  };

  useEffect(() => {
    // Initial resize check on component mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, [AIGenerated]); */

  return (
    <div>
      <div className='px-5 sm:px-10 flex flex-col items-center justify-center'>

        <div className='relative w-full h-full mb-5 sm:mb-10'>
          <img src={contact} alt="assistance-banner" className='w-full h-full'/>
          <div className='absolute top-0 w-full h-full bg-black/40 flex items-center justify-center'>
            <h1 className='text-2xl sm:text-4xl font-medium text-white drop-shadow-md'>Soulscript</h1>
          </div>
        </div>
        <div className='flex flex-col text-neutral-700 items-center pb-7 sm:pb-10 justify-center'>
          <h1 className='text-black text-3xl sm:text-4xl font-medium'>Free Obituary Soulscript 📝</h1>

          <p className='mt-4 sm:mt-8 md:w-3/4 sm:text-center'>Welcome to SoulScript, the thoughtful and easy-to-use obituary writing tool from St. Albans Digital Printing Inc. Designed to help you celebrate a life with love, SoulScript uses AI technology to help you create heartfelt tributes that truly reflect the life and legacy of your loved one.<br/></p>
          <p className='mt-4 sm:mt-8 md:w-3/4 sm:text-center'>Whether you're preparing a notice for a newspaper, composing a eulogy, or creating an online remembrance, SoulScript guides you gently through the process. Its streamlined design allows you to craft a meaningful, polished obituary tailored in tone and content—ensuring your words genuinely capture the spirit of the person you're honoring. The final tribute is suitable for memorial services, printed announcements, or digital platforms.<br/></p>
          <p className='mt-4 sm:mt-8 md:w-3/4 sm:text-center'>No writing experience is necessary. With just a few key details, SoulScript generates a complete and professionally styled obituary. When words are hard to find, SoulScript helps you express them with sincerity, clarity, and grace.<br/></p>

        </div>
        <div className='flex justify-center w-full pt-8 pb-4 sm:pb-12'>

          <div className='w-full sm:w-11/12 md:w-3/4 lg:w-2/3 px-4 py-4 sm:px-8 sm:py-8 bg-neutral-50 shadow-[0_0_10px_4px_rgba(0,0,0,0.1)] rounded-xl'>
            <div className='flex flex-col items-start justify-start'>
              {Object.entries(inputValue).map(([key, value]) => {
                const formattedkey = key === 'educationCareerHobbiesAndInterests' 
                  ? 'Education, career, hobbies and interests' 
                  : key === 'additionalInformationLikeChildhoodOrSpecialBond' 
                  ? 'Additional information, like childhood or special bond'
                  :  key === 'akaAlsoKnownAs' 
                  ? 'AKA, also known as'
                  :key.replace(/([A-Z])/g, ' $1')
                    .replace(/^./, (str) => str.toUpperCase())
                    .toLowerCase()
                    .replace(/^\w/, (c) => c.toUpperCase())

                return (
                <div key={key} className='w-full mt-2 md:mt-4'>
                  <label className='text-neutral-700 text-sm md:text-[15px] font-medium'>
                    {formattedkey}
                  </label>
                  {error && (
                    <p className="text-sm relative left-3 min-[1600px]:text-[15px] text-red-700/90 p-1 bg-red-400/30 rounded-t-md">This field is required.</p>
                  )}  
                  <input 
                    type="text" 
                    name={key}
                    className={`assistanceClass border ${error ? 'mt-0' : 'mt-[6px]'} border-neutral-300 rounded focus:shadow-[0_0_10px_-5px_rgba(0,0,0,0.5)] transition-shadow duration-200 focus:outline-none px-3 py-1 md:py-2 w-full`}
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  />
                </div>
              )}
              )}
              {typeof AIGenerated === 'object' && <pre>{JSON.stringify(AIGenerated, null, 2)}</pre>}
              
              <div className='mt-6 md:mt-8 w-full'>
                {skeletonArea && (
                  <div className='flex flex-col border border-neutral-300 rounded focus:shadow-[0_0_10px_-5px_rgba(0,0,0,0.5)] transition-shadow duration-200 focus:outline-none p-2 w-full min-h-60'>
                    <Skeleton width='100%' height='20px' marginBottom='8px'/>
                    <Skeleton width='100%' height='20px' marginBottom='8px'/>
                    <Skeleton width='100%' height='20px' marginBottom='8px'/>
                    <Skeleton width='60%' height='20px' marginBottom='20px'/>
                    <Skeleton width='100%' height='20px' marginBottom='8px'/>
                    <Skeleton width='100%' height='20px' marginBottom='8px'/>
                    <Skeleton width='100%' height='20px' marginBottom='8px'/>
                    <Skeleton width='20%' height='20px' marginBottom='8px'/>
                  </div>
                )}
                {AIGenerated ? (
                  <>
                    <p className='text-sm min-[1600px]:text-[15px] text-neutral-600 p-1 leading-4'>If you want to add more details, simply fill out the form again and hit "Generate" to create new content.</p>
                    <textarea style={{minHeight:'85vh'}} ref={aiContentRef} value={AIGenerated} onChange={(e) => setAIGenerated(e.target.value)} className='border border-neutral-300 rounded-t sm:rounded focus:shadow-[0_0_10px_-5px_rgba(0,0,0,0.5)] transition-shadow duration-200 focus:outline-none p-2 w-full min-h-90vh'></textarea>
                    <p className='text-sm sm:inline-block -mt-[6px] sm:relative sm:left-3 min-[1600px]:text-[15px] text-neutral-600 p-1 bg-neutral-400/25 rounded-b-md leading-4'>* AI-generated content may contain minor errors <br/>– please review carefully before use.</p>

                  </>
                ) : (<p className='text-center text-neutral-600/60'><span className='text-neutral-600/30'>--</span> AI-generated content will appear here <span className='text-neutral-600/30'>--</span></p>)}          
              </div>

              <button 
                onClick={handleSubmit}
                className= 'mt-4 px-4 py-2 bg-orange-500/80 text-white hover:bg-orange-500 hover:text-white duration-200 rounded'
              >
                Generate
              </button>
            </div>
          </div>    

        </div>

      </div>

    </div>
  )
}

export default SoulScript;
